// extracted by mini-css-extract-plugin
export default {"buttons":"DeleteModal_buttons__ZDYTd","idSpan":"DeleteModal_idSpan__OwouU"};